module.exports = __webpack_public_path__ + "static/media/wand_.92dd49d3.png";